import ReportResearch from './reportResearch'
export default ReportResearch
